
    import "src/shared/components/MultipleFilterComponent/index.module.scss?farm_css_modules";
    
    export default {"buttonGroup": `buttonGroup-46f2735f`,"filterButton": `filterButton-46f2735f`,"orderStatusFilter": `orderStatusFilter-46f2735f`}
    